// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"c46cce60","313":"e7bf3577","322":"12e76364","326":"d78df8fe","422":"30caeedb","558":"6f0d7de7","654":"8d10aeb6","671":"267c913d","837":"80bc3d2e"}[chunkId] + ".chunk.js";
};